import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconLens: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLens"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M8.00189 14.3088V9.69023M8.00189 14.3088L12.0021 16.6183M8.00189 14.3088L2.64053 11.2137M8.00189 9.69023L12.0021 7.38072M8.00189 9.69023L8.00189 3.49963M12.0021 7.38072L16.0019 9.69001M12.0021 7.38072L17.3635 4.28549M16.0019 9.69001L16.0019 14.309M16.0019 9.69001L21.3631 12.7853M16.0019 14.309L12.0021 16.6183M16.0019 14.309L16.0019 20.4996M12.0021 16.6183L6.64103 19.7137" stroke="currentColor"/></CentralIconBase>;
});

export default IconLens;
